import store from '@/store';

export default function createRouteStack(to, _, next) {
    const routeStack = store.getters.getRouteStack;

    if (to.path == "/") {
        store.commit('restoreStack');
        next();
        return;
    }

    if (!routeStack.includes(to.path)) {
        store.commit('routeStack', to.path);
    }
    next();
}